import { Component, OnInit, EventEmitter, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CONSTANTS } from 'src/app/core/config/constants';
import { CommonService } from 'src/app/core/helper/common.service';
import { DataStorage } from 'src/app/core/helper/data.storage';
import { PmdSidebar } from 'src/app/shared/propeller';
import { LayoutService } from '../layout.service';

@Component({
  selector: 'app-customer-navbar',
  templateUrl: './customer-navbar.component.html',
  styleUrls: ['./customer-navbar.component.scss'],
  host: {
    class:'container-fluid',
  }
})
export class CustomerNavbarComponent implements OnInit {

  @ViewChild(PmdSidebar) leftSidebar ;
  invoiceData:any;

  constructor( private router: Router, 
    private activatedRoute: ActivatedRoute, 
    private dataStorage: DataStorage, 
    private commonService : CommonService,
    private layoutService: LayoutService
  ) {   

  }

  // languageForm: FormGroup;
  language = 'en';
  languages = [
    { id: 'en', name: 'English' },
    { id: 'sp', name: 'Spanish' },
    { id: 'fr', name: 'French' },
    { id: 'ar', name: 'Arabic' },
    { id: 'ru', name: 'Russian'}
  ];

  changeLang(){
    // console.log('===========change language======', this.language)
    this.commonService.changeLanguage(this.language)
  }

  ngOnInit(){
   //display invoice data
    this.layoutService.getCustomerViewInvoiceData().subscribe({
      next: (response) => { 
          this.invoiceData=response;
      },
      error: (e) => {
        this.commonService.handleSubscribeError(e);
      }
    });
  }

  toggleSideBar(){
    // this.leftSidebar.toggleSideBar();
    this.commonService.sideBarToggle.emit();
  }
  print(){
    window.print();

  }
}
